import cardsData from '../cards/twentyCardsFourPromoted.json';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../../apiTypes';
import type { cardBubbleType } from '../../../types';

export const cardsMock = {
  searchCardsSummaryBubbles: (
    queryString: string,
  ): Promise<wrappedApiResponseType<Array<cardBubbleType>>> => {
    console.log('cardsMock.searchCardsSummaryBubbles');
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: {},
    });
  },

  searchCards: (queryString: string): djangoModelApiResponse<any> => {
    console.log('cardsMock.searchCards');
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: cardsData,
    });
  },

  searchNationwides: (
    mapLocation,
    categoryIds,
    cardTypes,
    searchKeyword = '',
    pageSize,
    offset,
  ): djangoModelApiResponse<any> => {
    console.log('cardsMock.searchNationwides');
    const filteredCards = cardsData.results.filter(
      card => card.card_type === cardTypes,
    );
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: {
        results: filteredCards.slice(offset, offset + pageSize),
        count: filteredCards.length,
      },
    });
  },

  searchCardsCount: (queryString: string): djangoModelApiResponse<any> => {
    console.log('cardsMock.searchCardsCount');
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: { count: cardsData.results.length },
    });
  },

  searchCardsSummary: (queryString: string): djangoModelApiResponse<any> => {
    console.log('cardsMock.searchCardsSummary');
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: { results: cardsData.results },
    });
  },

  getSingle: (id: string): djangoModelApiResponse<any> => {
    console.log('cardsMock.getSingle');
    const card = cardsData.results.find(card => card.id === parseInt(id, 10));

    if (card) {
      return Promise.resolve({
        status: 200,
        statusText: 'OK',
        body: card,
      });
    } else {
      return Promise.reject({
        status: 404,
        statusText: 'Not Found',
      });
    }
  },

  searchCardsWithPromoted: (
    queryString: string,
  ): djangoModelApiResponse<any> => {
    console.log('cardsMock.searchCardsWithPromoted');
    return Promise.resolve({
      status: 200,
      statusText: 'OK',
      body: cardsData,
    });
  },
};
